module.exports = __webpack_public_path__ + "static/media/ht.5f6a49d0.svg";